const getters = {
    token: state => state.user.token,
    platform: state => state.platform,
    banner: state => state.banner
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js